import { render, staticRenderFns } from "./cpt-dot-loading.vue?vue&type=template&id=508ea9e8&scoped=true"
import script from "./cpt-dot-loading.vue?vue&type=script&lang=js"
export * from "./cpt-dot-loading.vue?vue&type=script&lang=js"
import style0 from "./cpt-dot-loading.vue?vue&type=style&index=0&id=508ea9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0_46uom3ic6e7zmr6qh5t5ayckj4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ea9e8",
  null
  
)

export default component.exports